function openLinkInNewTab(link: string) {
  if (window) {
    window.open(link, "_blank")?.focus();
  }
}
export default openLinkInNewTab;
